import { render, staticRenderFns } from "./InvestorProjectsView.vue?vue&type=template&id=652560a0&scoped=true"
import script from "./InvestorProjectsView.vue?vue&type=script&lang=js"
export * from "./InvestorProjectsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652560a0",
  null
  
)

export default component.exports